import { useState } from "react";
import { useParams } from "react-router-dom";

import { appManagementActions, superAppActions } from "@/redux/actions";
import { SavePageContainer } from "@/components";
import AppForm from "./AppForm";
import paths from "@/constants/paths";
import VersionForm from "./VersionForm";

const SavePage = () => {
    const { id } = useParams();
    const isCreating = !id;
    const [activeTabKey, setActiveTabKey] = useState("1");

    const getBreadcrumbs = (data) => {
        return [
            { breadcrumbName: "Quản lý Super App", path: paths.superAppList },
            { breadcrumbName: isCreating ? "Tạo mới mini app" : data?.appName, path: "avoidDuplicateKey" },
        ];
    };

    const tabs = [
        { key: "1", label: `Thông tin chung` },
        { key: "2", label: `Phiên bản`, disabled: isCreating },
    ];

    const onChangeTab = (tabKey) => {
        setActiveTabKey(tabKey);
    };

    const renderFormByTab = () => {
        switch (activeTabKey) {
            case "2":
                return VersionForm;
            default:
                return AppForm;
        }
    };

    const isTabInfo = activeTabKey === "1";

    return (
        <SavePageContainer
            form={renderFormByTab()}
            isCreating={!id}
            objectName="App"
            listUrl={paths.superAppList}
            detailUrl={paths.superAppDetail}
            createAction={superAppActions.create}
            updateAction={isTabInfo ? superAppActions.updateInfo : superAppActions.updateVersion}
            getDetailAction={superAppActions.getDetail}
            getBreadcrumbs={getBreadcrumbs}
            tabs={tabs}
            isRefreshUpdateSuccess={true}
            onChangeTab={onChangeTab}
        />
    );
};

export default SavePage;
